import { useEffect, useState } from "react";
import { X, BadgePercent } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ExitIntentOffer = ({ source = "exit-intent" }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("nrc_exit_offer_shown") || localStorage.getItem("nrc_offer_claimed")) return;
    let armed = false;
    const armTimer = setTimeout(() => { armed = true; }, 5000);
    const onOut = (e) => {
      if (!armed || e.relatedTarget || e.clientY > 0) return;
      sessionStorage.setItem("nrc_exit_offer_shown", "1");
      setOpen(true);
      document.removeEventListener("mouseout", onOut);
    };
    document.addEventListener("mouseout", onOut);
    return () => {
      clearTimeout(armTimer);
      document.removeEventListener("mouseout", onOut);
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/shop/offer", { email, source });
      localStorage.setItem("nrc_offer_claimed", "1");
      toast.success(r.data.message || "Sent. Check your inbox.");
      setDone(true);
    } catch {
      toast.error("Something broke. Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div
      data-testid="exit-offer-overlay"
      className="fixed inset-0 z-[999] bg-black/70 backdrop-blur-sm flex items-center justify-center p-5"
      onClick={() => setOpen(false)}
    >
      <div
        data-testid="exit-offer-modal"
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-lg bg-ink border border-white/25 p-8 lg:p-10"
      >
        <button
          data-testid="exit-offer-close"
          onClick={() => setOpen(false)}
          aria-label="Close offer"
          className="absolute top-4 right-4 text-white/50 hover:text-white p-1 transition-colors duration-150"
        >
          <X size={18} />
        </button>
        <div className="flex items-center gap-3">
          <BadgePercent size={20} className="text-white/60" />
          <p className="font-mono-label text-white/40">BEFORE YOU GO</p>
        </div>
        <h3 className="font-display text-3xl lg:text-4xl mt-4">WAIT — TAKE 25% OFF.</h3>
        {done ? (
          <div data-testid="exit-offer-success" className="mt-5 border border-white/25 p-5">
            <p className="font-mono-label text-white/80">✓ CODE SENT. CHECK YOUR INBOX.</p>
            <p className="text-white/50 text-sm mt-2">It expires in 7 days. Enter it at checkout on any piece.</p>
          </div>
        ) : (
          <>
            <p className="text-white/50 text-sm mt-3">
              Any piece of merch, one code, <span className="text-white font-semibold">expires in 7 days</span>. Where should we send it?
            </p>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 mt-6">
              <input
                data-testid="exit-offer-email"
                type="email"
                required
                placeholder="EMAIL ADDRESS"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent border-b border-white/30 py-3 text-sm placeholder:text-white/30 focus:border-white transition-colors duration-200"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="exit-offer-submit"
                className="btn-invert font-mono-label bg-white text-ink border border-white px-6 py-3.5 hover:bg-transparent hover:text-white disabled:opacity-50 shrink-0"
              >
                {loading ? "SENDING..." : "SEND MY CODE"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
